(function ($) {
    const prefix = "data-fd-";


    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */

    /**
     * Loop through data-fd-* attributes to build the options object, then enable the control
     * Current restriction - all widgets can only accept functions in a parameter called 'callback'
     * @param {HTMLElement} elem
     */
    function enableControl(elem) {
        const $elem = $(elem),
            options = {};

        $.each(elem.attributes, function () {
            if (!this.specified) { // Skip empty attributes
                return true;
            }

            if (this.name.indexOf(prefix) === 0) { // Only pull options from data-fd-* attributes
                const attributeName = this.name.substring(prefix.length);
                if (attributeName.endsWith('callback')) {
                    options[attributeName + "_RAW"] = this.value;
                    if (this.value.startsWith("FD")) {
                        const parts = this.value.split('.');
                        options[attributeName] = FD[parts[1]][parts[2]];
                    } else {
                        if (!options['namespace']) {
                            options['namespace'] = $elem.attr('data-fd-namespace') || 'Page';
                        }
                        options[attributeName] = FD[options.namespace][this.value];
                    }
                } else {
                    options[attributeName] = $elem.data('fd-' + attributeName);
                }
            }

            return true;
        });
        if ($elem['control_' + options.control] === undefined) {
            console.error('"data-fd-control=' + options.control + '" is not a valid JavaScript control widget.');
        } else {
            $elem['control_' + options.control]($elem, options);
        }
    }


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */


    $.fn.enableControls = function () {
        const formQueue = [];
        $.each($("[" + prefix + "control]", this), function () {
            if ($(this).data('fd-control') === 'form') {
                formQueue.push(this);
            } else {
                enableControl(this);
            }
        });

        // Set form elements last so that control-specific events fire first
        for (var x = 0; x < formQueue.length; x++) {
            enableControl(formQueue[x]);
        }
        this.enableTooltips({ boundary: "window" });
        this.enablePopovers();

        return this;
    };
}(jQuery));